import React from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import {
  Section,
  Hr,
  Ul,
  Li,
  AnswerBox,
  Question,
  Answer,
} from './faq.style';

import { EMPLOYERS_TITLE } from '../../../constants/titles';


const EmployersFaq = ({ setTitle }) => {

  setTitle(EMPLOYERS_TITLE);

    return (
        <div>
            <Section>
                <Ul>
                    <Link to="#question1" smooth={true}>
                        <Li>I’d love to list a job. How do I do it?</Li>
                    </Link>
                    <Link to="#question2" smooth={true}>
                        <Li>My workplace has integrated inclusive practices into the way we operate but we don't meet your criteria. How can we platform the work we are doing?</Li>
                    </Link>
                    <Link to="#question3" smooth={true}>
                        <Li>How much does it cost to list a job?</Li>
                    </Link>
                    <Link to="#question4" smooth={true}>
                        <Li>I’d like to hire young people.</Li>
                    </Link>
                </Ul>
            </Section>
            <Hr />
            <Section>
                <AnswerBox>
                    <Question id="question1">I’d love to list a job. How do I do it?</Question>
                    <Answer>
                        As long as you meet our criteria, which you can view here, you can list on our site. If you don’t please get in touch as we can help you in some quick and straightforward ways to improve the way you nurture the diverse talent you want to hire.
              </Answer>
                </AnswerBox>
                <AnswerBox>
                    <Question id="question2">My workplace has integrated inclusive practices into the way we operate but we don't meet your criteria. How can we platform the work we are doing?</Question>
                    <Answer>
                        We understand that there are many different steps companies could be taking to reduce bias in their recruitment practices and tokenistic diversity in the workplace. With our jobs board we are offering one simple solution to a very complex issue. As we grow, we hope to platform more individualised action being taken across various organisations. We'd love to hear about the work you're doing so please do contact us.
              </Answer>
                </AnswerBox>
                <AnswerBox>
                    <Question id="question3">
                        How much does it cost to list a job?
              </Question>
                    <Answer>
                        For now, its free. Lucky you! We are in start-up mode, soon there will be a pricing structure so hurry to get in touch in the meantime.
              </Answer>
                </AnswerBox>
                <AnswerBox>
                    <Question id="question4">
                        I’d like to hire young people.
              </Question>
                    <Answer>
                        Please get in touch. We run a talent programme unlike any other. We take a strengths-based approach to getting undiscovered talent ready to work with you. We have seen it working in practice and would love the chance to come and tell you more about it.
              </Answer>
                </AnswerBox>
            </Section>
        </div>
    );
};

export default EmployersFaq;
